import { toast } from 'react-toastify';

import { tags as applicationTags } from './application';
import { apiSlice } from '../apiSlice';
import axios from '../../utils/axios';
import invalidateTags from '../invalidateTags';

const tags = {
  documents: 'documents',
};

const documentsApi = apiSlice
  .enhanceEndpoints({ addTagTypes: Object.values(tags) })
  .injectEndpoints({
    endpoints: (build) => ({

      getDocuments: build.query({
        queryFn: async ({ application_uuid }, api) => {
          try {
            const response = await axios({
              url: `${baseURL}/documents/${application_uuid}`,
              method: 'GET',
            });

            // Force meter_documents refresh (is updated on this fetch route)
            if (response.data.meter_documents) {
              api.dispatch(documentsApi.util.invalidateTags([applicationTags.application]));
            }

            return { data: response.data.documents };
          } catch (error) {
            console.error(error.response);
            return { error: error.message };
          }
        },
        providesTags: [tags.documents],
      }),



      uploadDocuments: build.mutation({
        queryFn: async ({ type, file, application_uuid }) => {
          try {
            const formData = new FormData();
            formData.append('document', file);
            const response = await axios({
              url: `${baseURL}/documents/upload/${application_uuid}/${type}`,
              method: 'POST',
              data: formData,
              headers: { 'content-type': 'multipart/form-data' },
            });
            toast.success('Document Uploaded');
            return { data: response.data };
          } catch (error) {
            if (error.response?.data?.message === 'Invalid file format.') {
              toast.error(`Invalid file type. Please upload a different file. ${error.response?.data?.supported_type ? `Supported file types: ${error.response?.data?.supported_type}` : ''}`);
            }
            console.error(error.response);
            return { error: error.message };
          }
        },
        invalidatesTags: invalidateTags([tags.documents, applicationTags.application]),
      }),



      downloadDocument: build.query({
        queryFn: async ({ document_uuid, application_uuid }) => {
          try {
            const response = await axios({
              url: `${baseURL}/documents/download/${document_uuid}/${application_uuid}`,
              method: 'GET',
              responseType: 'blob',
            });
            const a = document.createElement('a');
            const [, fileName] = response.headers['content-disposition'].split('filename=');
            a.download = decodeURI(fileName);
            a.href = window.URL.createObjectURL(new Blob([response.data]));
            document.body.append(a);
            a.click();
            return { data: fileName };
          } catch (error) {
            console.error(error.response);
            return { error: error.message };
          }
        },
        providesTags: [],
      }),



      downloadTemplateDocument: build.query({
        queryFn: async (payload) => {
          try {
            const response = await axios({
              url: `${baseURL}/document-templates/${payload}`,
              method: 'GET',
              responseType: 'blob',
            });
            const a = document.createElement('a');
            const [, fileName] = response.headers['content-disposition'].split('filename=');
            a.download = decodeURI(fileName);
            a.href = window.URL.createObjectURL(new Blob([response.data]));
            document.body.append(a);
            a.click();
            return { data: fileName };
          } catch (error) {
            console.error(error.response);
            toast.error('It looks like something went wrong. Please try again.');
            return { error: error.message };
          }
        },
        providesTags: [],
      }),



      uploadManualSignature: build.mutation({
        queryFn: async ({ file, application_uuid }) => {
          try {
            const formData = new FormData();
            formData.append('document', file);
            const response = await axios({
              url: `${baseURL}/documents/upload/signatures/manual/${application_uuid}`,
              method: 'POST',
              data: formData,
              headers: { 'content-type': 'multipart/form-data' },
            });
            toast.success('Document Uploaded');
            return { data: response.data };
          } catch (error) {
            console.error(error.response);
            return { error: error.message };
          }
        },

        invalidatesTags: invalidateTags([tags.documents, applicationTags.application]),
      }),

    }),
  });

export const {
  useGetDocumentsQuery,
  useLazyDownloadTemplateDocumentQuery,
  useUploadDocumentsMutation,
  useLazyDownloadDocumentQuery,
  useUploadManualSignatureMutation,
} = documentsApi;
